import { render, staticRenderFns } from "./Backstretch.vue?vue&type=template&id=1c3fa985&"
import script from "./Backstretch.vue?vue&type=script&lang=js&"
export * from "./Backstretch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports